import { NICmsContentComponent } from '@icms/core/content';

export namespace NCmsComponentMenu {
    export const ID = 'menu';

    export interface IData extends NICmsContentComponent.IData {
        menu: IMenuItem[];
        color?: string;
        text_style?: string;
    }

    export interface IMenuItem {
        // line copy
        text: string;
        // line link
        link?: string;
        // link colour
        color?: string;
        // subcomponents
        components: [];
        hide: boolean;
        indent: boolean;
    }
}
